export default '/build/e6a715cf.jpg'